import { render, staticRenderFns } from "./disagreement-table.vue?vue&type=template&id=92574400&"
import script from "./disagreement-table.vue?vue&type=script&lang=js&"
export * from "./disagreement-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92574400')) {
      api.createRecord('92574400', component.options)
    } else {
      api.reload('92574400', component.options)
    }
    module.hot.accept("./disagreement-table.vue?vue&type=template&id=92574400&", function () {
      api.rerender('92574400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/disagreement-table.vue"
export default component.exports